import { mainApi } from 'services/mainApi'
import { ReadNotificationListParams } from './types';
import { getAdditionParameterListFromQueryParameterList } from 'shared/lib/getAdditionParameterListFromQueryParameterList';

export const notificationsApi = mainApi
    .enhanceEndpoints({
        addTagTypes:[`LocationTips`]
    })
    .injectEndpoints({
        endpoints: (builder) => ({
            emailTest: builder.mutation<any, void>({
                query: () => {
                    let url = `/notifications/emailtest`
                    return url
                },
            }),  
            readNotificationList : builder.query({
                query: (params: ReadNotificationListParams) => {
                    let url = `/notifications`
                    const additionalParams: any[] = getAdditionParameterListFromQueryParameterList(params)
                    
                    if (additionalParams.length > 0) {
                        const paramsString: string = additionalParams
                            .map((additionalParam) => {
                                if (Array.isArray(additionalParam.value)) {
                                    return additionalParam.value.map((item: any) => `${additionalParam.name}=${item}`).join('&');
                                }


                                return `${additionalParam.name}=${additionalParam.value}`;
                            })
                            .join('&');

                        url = `${url}?${paramsString}`
                    }

                    return url
            },
        }), 
        }),
    })

export const {
    useReadNotificationListQuery,
    useEmailTestMutation,
} = notificationsApi
